import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const FooterContainer = styled("footer")(({ theme }) => ({
  backgroundColor:  theme.palette.blackLight.main,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    backgroundImage:
      "radial-gradient(100.6rem 78.9rem at 80% center, rgba(255, 255, 255, 0.21), transparent 37.4rem)"
  }
}));

export const FooterContent = styled(Box)(({ theme }) => ({
  display: "flex",
  flexWrap: "wrap",
  marginLeft: "auto",
  marginRight: "auto",
  padding: "2.6rem 1rem",
  maxWidth: "112.4rem",
  color: "white",
  textAlign: "center",
  [theme.breakpoints.up("sm")]: {
    textAlign: "left",
    padding: "4rem 2rem"
  }
}));

export const FooterFirstDiv = styled(Box)(({ theme }) => ({
  flex: "100%",
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    flex: "50%",
    width: "39.1rem"
  }

}));

export const FooterSecondDiv = styled(Box)(({ theme }) => ({
  flex: "100%",
  [theme.breakpoints.up("sm")]: {
    flex: "50%",
    textAlign: "right"
  }
}));
